import React from 'react'

import {
  CardContainer,
  Container,
  NameInfo,
  CardImages,
} from './cardImage.style'

const CardImage = ({ onClick, src, text }) => {
  return (
    <CardContainer onClick={onClick}>
      <div style={{ width: '100%' }}>
        <Container>
          <CardImages>
            <img src={src} alt='card infomation'loading="lazy" />
          </CardImages>
        </Container>
        <NameInfo>{text}</NameInfo>
      </div>
    </CardContainer>
  )
}

export default CardImage
